import angular from "angular";
import {Kontekst} from "../tjenester/Kontekst";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";
import _ from "lodash";

export function featureForInjisering() {
    return [regNavn.ng.$animate, Kontekst.regNavn, feature];
}

/**
 * Attributt-direktiv som skjuler taggen dersom feature ved angitt navn
 * ikke er aktivert for aktiv bruker.
 *
 * Dersom featurenavn prefikses med '!' vises taggen dersom featuren IKKE er aktivert for aktiv bruker.
 *
 * Bruk: <a feature="planvisning">....</a>, elementet vil vises dersom kontekst.erFeatureAktivert("planvisning") returnerer sann.
 */
export function feature($animate, kontekst: Kontekst): any /*IDirective */ {

    //KOPIERT FRA angualar.js
    var slice = [].slice;
    var jqLite = angular.element;

    function getBlockNodes(nodes) {
        // TODO(perf): update `nodes` instead of creating a new object?
        var node = nodes[0];
        var endNode = nodes[nodes.length - 1];
        var blockNodes;

        for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
            if (blockNodes || nodes[i] !== node) {
                if (!blockNodes) {
                    blockNodes = jqLite(slice.call(nodes, 0, i));
                }
                blockNodes.push(node);
            }
        }

        return blockNodes || nodes;
    }

    //KOPIERT FRA angualar.js (ngIfDirective)
    return {
        multiElement: true,
        transclude: 'element',
        priority: 600,
        terminal: true,
        restrict: 'A',
        $$tlb: true,
        link: function ($scope, $element, $attr, ctrl, $transclude) {
            let block, childScope, previousElements;
            const featureSpec = $attr.feature;
            const negert = _.startsWith(featureSpec, '!');
            const featureNavn = _.trimStart(featureSpec, '!');

            const featureAktivert = kontekst.erFeatureAktivert(featureNavn);
            const visElement = featureAktivert && !negert || !featureAktivert && negert;

            console.log(`feature: ${featureSpec}, viser element ${visElement}`)

            if (visElement) {
                if (!childScope) {
                    $transclude(function (clone, newScope) {
                        childScope = newScope;
                        clone[clone.length++] = document.createComment(' end feature: ' + $attr.feature + ' ');
                        // Note: We only need the first/last node of the cloned nodes.
                        // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                        // by a directive with templateUrl when its template arrives.
                        block = {
                            clone: clone
                        };
                        $animate.enter(clone, $element.parent(), $element);
                    });
                }
            } else {
                if (previousElements) {
                    previousElements.remove();
                    previousElements = null;
                }
                if (childScope) {
                    childScope.$destroy();
                    childScope = null;
                }
                if (block) {
                    previousElements = getBlockNodes(block.clone);
                    $animate.leave(previousElements).then(function () {
                        previousElements = null;
                    });
                    block = null;
                }
            }
        }
    };

}

